"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderTabLoader = void 0;
const react_1 = __importDefault(require("react"));
const Skeleton_1 = __importDefault(require("@mui/material/Skeleton"));
const style_1 = require("./style");
function HeaderTabLoader() {
    return (react_1.default.createElement(style_1.TabLoaderWrapper, null,
        react_1.default.createElement(Skeleton_1.default, { sx: { bgcolor: "#00A9E0" }, width: 45, height: 25 }),
        react_1.default.createElement(Skeleton_1.default, { sx: { bgcolor: "#00A9E0" }, width: 45, height: 25 }),
        react_1.default.createElement(Skeleton_1.default, { sx: { bgcolor: "#00A9E0" }, width: 45, height: 25 }),
        react_1.default.createElement(Skeleton_1.default, { sx: { bgcolor: "#00A9E0" }, width: 45, height: 25 }),
        react_1.default.createElement(Skeleton_1.default, { sx: { bgcolor: "#00A9E0" }, width: 45, height: 25 })));
}
exports.HeaderTabLoader = HeaderTabLoader;
